<template>
  <div id="cell" v-on:click="onclickself">
    <template v-if="a">{{ text }}</template>
    <template v-else></template>
  </div>
</template>

<script>
//node中向外暴露成员：moudule.exports={}和exports，导入模块：var 名称=require('标识符')
//ES6中导入：import xxx form xx，导出：export default和export 向外暴露
//两种不能混用
//export导出，导入时要加{}:按需导出，export 可以向外导出多个成员，import时如果不需要，可以不在{}中定义
//export导出的成员，导入时必须严格按照名称{}按需接受 想换名字可以使用as 起别名
// export default 导出的成员，可以使用任意变量接收，导入时不需要加{} 一个文件中，export可以有多个，export default只可以有一个
export default {
  //父组件使用v-bind或简化指令传递数据给子组件
  //子组件通过props接收，只能读不能更改
  props: ["n"],
  data() {
    //:() => {
    //function(){}
    //return (x = 1);
    return { a: false, text: "o" };
  },
  methods: {
    onclickself() {
      if (this.a === true) {
        return;
      } else {
        this.a = true;
        this.text = this.n % 2 === 0 ? "x" : "o";
        //父组件通过v-on把其方法引用传递给子组件，子组件通过$emit,调用父组件方法，并把数据传给父组件使用
        this.$emit("click", this.text);
      }
    },
  },
};
</script>

<style>
#cell {
  border: 1px solid black;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 80px;
}
</style>
